<template>
    <v-flex xl12>
        <h2>Anúncios <span class="text-title-header"> | Cadastro de anúncios</span></h2>
        <v-divider></v-divider>
        <br/>
        <router-view></router-view>
    </v-flex>
</template>
<script>
export default {
  name: 'advertisers',
  mounted: function () {
    this.$nextTick(function () {

    })
  }
}
</script>
